import http from '../../../utils/http';

const list = params =>
  http({
      url: '/coupon/list',
      params
    })
    .then(data => {
      if (data.code) {
        return Promise.reject(data)
      }
      return data
    })

export default {
	list,
};
